import { applyAuthUserUpdate } from "../../config/runtime";
import { gaTrackEvent } from "../../analytics/ga4";

export function applyPredictionUserUpdate({ authUser, predictionResponse, onCreditsUpdate }) {
  const feature = predictionResponse?.prediction?.feature;
  if (feature != null && String(feature).trim() !== "") {
    gaTrackEvent("reading_generated", { feature: String(feature) });
  }

  const nextUser = predictionResponse?.user;
  if (authUser && nextUser) {
    applyAuthUserUpdate(authUser, nextUser);
  }
  const rawCredits = nextUser?.credits_balance ?? nextUser?.creditsBalance ?? authUser?.creditsBalance ?? authUser?.credits_balance;
  const normalizedCredits = Number(rawCredits);
  if (Number.isFinite(normalizedCredits)) {
    onCreditsUpdate?.(normalizedCredits);
  }
}
